import React, { Component } from "react";
import * as Icon from "react-feather";
import clsx from "clsx";
import "./file-drop-zone.css";

class FileDropZone extends Component {
	state = { isDragging: false };

	onDragOver = event => {
		event.preventDefault();
		if (!this.state.isDragging) this.setState({ isDragging: true });
	};

	onDragLeave = event => {
		event.preventDefault();
		this.setState({ isDragging: false });
	};

	onDrop = event => {
		event.preventDefault();
		this.setState({ isDragging: false });
		this.props.onFiles(event.dataTransfer.files);
	};

	onInputChange = event => {
		this.props.onFiles(event.target.files);
		event.target.value = "";
	};

	render() {
		const { accept, multiple = false, title, subtitle, className } = this.props;
		const { isDragging } = this.state;

		return (
			<label
				className={clsx("file-drop-zone", isDragging && "file-drop-zone--dragging", className)}
				onDragOver={this.onDragOver}
				onDragLeave={this.onDragLeave}
				onDrop={this.onDrop}
			>
				<Icon.UploadCloud size={22} className="file-drop-zone__icon" />
				<span className="file-drop-zone__title">{title}</span>
				{subtitle && <span className="file-drop-zone__subtitle">{subtitle}</span>}
				<input
					type="file"
					accept={accept}
					multiple={multiple}
					className="file-drop-zone__input"
					onChange={this.onInputChange}
				/>
			</label>
		);
	}
}

export default FileDropZone;
